@if (_form != null) {
    <form 
        [style.width]="fixedWidth != null ? fixedWidth + 'px' : (_form.useAbsolutePositions ? _form.getWidth() + 'px' : '100%')" 
        [style.height]="fixedHeight != null ? fixedHeight + 'px' : (_form.useAbsolutePositions ? _form.getHeight() + 'px' : undefined)" spellcheck="false">
        
        <app-sm-form-group [form]="_form" [fields]="_fields"></app-sm-form-group>
    </form>
}
